import COMMON_CONSTANTS from './module/common'
import WORK_ORDER from "@/constants/module/service";
import ORDER_CENTER from "@/constants/module/order-center";
import MARKETING_CONSTANTS from './module/marketing'
/**
 * 常量管理入口
 * @author gzq
 * @description
 *  1、通过引入模块，注册在enumInfo对象中
 *  2、模块命名以系统下的菜单命名，例如：ODER_SYSTEM,
 *  3、通过全局api this.$enum.getDescByValue(作用域, 枚举对象的key)获取枚举值
 * @example
 * this.$getEnumValue('COMMON_CONSTANTS', 'ORDER_TYPE')
 * 参考链接：https://www.npmjs.com/package/vue-enum/v/1.0.5
 */
const enumInfo = {
  ...COMMON_CONSTANTS,
  ...WORK_ORDER,
  ...ORDER_CENTER,
  ...MARKETING_CONSTANTS,
}
export default enumInfo
